import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyCUJeH3gEUzLRHCXY32fVmwopdD8KhK5Sw",
  authDomain: "nexedz.firebaseapp.com",
  projectId: "nexedz",
  storageBucket: "nexedz.firebasestorage.app",
  messagingSenderId: "786819441816",
  appId: "1:786819441816:web:cd1b548d5f873801e79ced",
  measurementId: "G-9P842V6F04"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;